<template>
  <v-dialog :value="true" max-width="500">
    <v-card class="pa-4" flat>
      <v-form @submit.prevent="deposit" v-model="isFormValid" ref="form">
        <v-card-text v-if="formVisibility" align="left">
          <h5 class="mt-4">Fuel FlexiFund with M-Pesa deposit!</h5>
          <v-text-field
            v-model="amount"
            :rules="[nonZeroNumberRule]"
            label="Amount"
            class="mt-7"
            outlined
            dense
          ></v-text-field>
          <v-btn
            class="transact white--text lowercase-text"
            block
            plain
            :loading="$store.state.loading.depositBtn.load"
            :disabled="$store.state.loading.depositBtn.disabled"
            type="submit"
          >
            Top up
          </v-btn>
        </v-card-text>
        <div v-else class="ma-4">
          <v-btn large fab depressed small dark color="#fff">
            <v-icon large color="transact">mdi-cellphone-key</v-icon>
          </v-btn>
          <h5>Phone check: Enter PIN to confirm.</h5>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close')">CLOSE</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return { amount: "", formVisibility: true, isFormValid: false };
  },
  computed: {
    nonZeroNumberRule() {
      return (value) => {
        if (!value) {
          return "Value is required";
        } else if (isNaN(value)) {
          return "Enter a valid number";
        } else if (parseFloat(value) === 0) {
          return "Number must not be zero";
        }
        return true;
      };
    },
  },
  methods: {
    async deposit() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("transactions/depositFunds", {
          amount: this.amount,
        });
        this.formVisibility = false;
        this.amount = "";
        this.closeDialog;
      }
    },
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
